import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { MessageProvider } from './contexts/MessageContext'
import Login from './pages/Auth/Login'
import Header from './components/Header'

import AdminUsersList from './pages/AdminUsers/AdminUsersList'
import NewAdminUser from './pages/AdminUsers/NewAdminUser'
import EditAdminUser from './pages/AdminUsers/EditAdminUser'
import EmailTemplatesList from './pages/EmailTemplates/EmailTemplatesList'
import NewEmailTemplate from './pages/EmailTemplates/NewEmailTemplate'
import EditEmailTemplate from './pages/EmailTemplates/EditEmailTemplate'
import ContentGroupsList from './pages/ContentGroups/ContentGroupsList'
import NewContentGroup from './pages/ContentGroups/NewContentGroup'
import EditContentGroup from './pages/ContentGroups/EditContentGroup'
import EmailAnalytics from './pages/EmailAnalytics/EmailAnalytics'

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading)
  
  if (isLoading) {
    return <div>Loading...</div>
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />
}

function AppContent() {
  const location = useLocation()
  const hideHeaderPaths = ['/login', '/forgot-password', '/reset-password']
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname)

  return (
    <div className="min-h-screen bg-gray-100">
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/email-templates" replace />} />
        <Route path="/email-templates" element={
          <ProtectedRoute>
            <EmailTemplatesList />
          </ProtectedRoute>
        } />
        <Route path="/new-email-template" element={
          <ProtectedRoute>
            <NewEmailTemplate />
          </ProtectedRoute>
        } />
        <Route path="/edit-email-template/:id" element={
          <ProtectedRoute>
            <EditEmailTemplate />
          </ProtectedRoute>
        } />
        <Route path="/admin-users" element={
          <ProtectedRoute>
            <AdminUsersList />
          </ProtectedRoute>
        } />
        <Route path="/new-admin-user" element={
          <ProtectedRoute>
            <NewAdminUser />
          </ProtectedRoute>
        } />
        <Route path="/edit-admin-user/:id" element={
          <ProtectedRoute>
            <EditAdminUser />
          </ProtectedRoute>
        } />
        <Route path="/content-groups" element={
          <ProtectedRoute>
            <ContentGroupsList />
          </ProtectedRoute>
        } />
        <Route path="/new-content-group" element={
          <ProtectedRoute>
            <NewContentGroup />
          </ProtectedRoute>
        } />
        <Route path="/edit-content-group/:id" element={
          <ProtectedRoute>
            <EditContentGroup />
          </ProtectedRoute>
        } />
        <Route path="/email-analytics" element={
          <ProtectedRoute>
            <EmailAnalytics />
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <MessageProvider>
          <AppContent />
        </MessageProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
